// this page contains temporary test stuff.
import { toast, Slide, cssTransition } from "react-toastify";
import "../styles/customToastStyle.scss";


const Msg = () => (
    <div>
     <h2> My title</h2>
     <p> Some test </p>
    </div>
  )
  

export default function Test() {

    return (
        <div className="testPage">

            <button onClick={() => {
                toast.info(
                    Msg,
                    { 
                        autoClose: 100000, 
                        transition: CustomTransition,  
                    }
                )
            }}>  
                Show Toast
            </button>
        </div>
    )
}
const CustomTransition = cssTransition({
    enter: 'toast-enter',
    exit: 'toast-exit',
});